import React from 'react';
import { Editor } from '@tinymce/tinymce-react';

import { API_TINY_KEY } from '../helpers/constants';

export default class RichTextEditor extends React.Component {

    render() {
        return (
            <Editor apiKey={API_TINY_KEY}
            value={this.props.value}
            onEditorChange={this.props.onChange}
            onClick={this.props.onClick}             
               init={{
                    height: 400,
                    menubar: false,
                    plugins: [
                        'advlist autolink lists link image imagetools charmap ',
                        'insertdatetime media table paste code ',
                    ],
                    toolbar: 'formatselect | fontselect | fontsizeselect | ' +
                        'bold italic underline forecolor backcolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist | ' +
                        'image | code | removeformat',
                        forced_root_block: false,

                    paste_preprocess: (plugin, args) => {
                        const urlRegex = /(https?:\/\/[^\s<]+)/g;

                        args.content = args.content.replace(urlRegex, (match) =>
                            `<a href="${match}" target="_blank" rel="noopener noreferrer">${match}</a>`
                        );
                    },
                    image_title: true,
                    automatic_uploads: true,
                    file_picker_types: 'image',
                    file_picker_callback: function (cb, value, meta) {
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');

                        input.onchange = function () {
                            var file = this.files[0];

                            var reader = new FileReader();
                            reader.onload = function () {
                                var id = 'blobid' + (new Date()).getTime();
                                var blobCache = window.tinymce.activeEditor.editorUpload.blobCache;
                                var base64 = reader.result.split(',')[1];
                                var blobInfo = blobCache.create(id, file, base64);
                                blobCache.add(blobInfo);

                                cb(blobInfo.blobUri(), { title: file.name });
                            };
                            reader.readAsDataURL(file);
                        };

                        input.click();
                    },
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                    language: 'pt_BR',
                    valid_children: '-a[strong]',
                    extended_valid_elements: 'strong/b',
                }}
            />
        )
    }
}